import styled, { css } from 'styled-components';

export const Progress = styled.div`
  ${({ theme }) => css`
    width: ${p => `${p.progress}%`};
    height: 100%;
    border-radius: 20px;
    background-color: ${p => p.color ? p.color : (theme?.colour?.primary ?? "#1DBD6B")};
  `}
`;
